import { useBrandRefreshActivationData } from '../brand_refresh_beta/useBrandRefreshActivationData'

/**
 * True when the user has opted into the product refresh experience via `activation_data`.
 * Defaults to false when unset or while the user record is loading.
 */
export function useProductRefreshUserOptIn(): boolean {
  const { blob } = useBrandRefreshActivationData()
  return blob.opted_in === true
}
